<template>
  <div v-if="Boolean(client)">
    <v-btn v-if="!isSidebar" small text @click="goBack"
      ><v-icon small color="primary">mdi-keyboard-backspace</v-icon> Back
    </v-btn>
    <v-list-group
      class="grey lighten-4"
      :disabled="client.currentAgeCategory != 'Preschool'"
      :append-icon="client.currentAgeCategory == 'Preschool' ? '$expand' : ''"
    >
      <template v-slot:activator>
        <v-list-item>
          <v-list-item-avatar horizontal>
            <v-icon x-large> mdi-account-circle </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title
              >{{ client.firstName }} {{ client.lastName }}</v-list-item-title
            >
            <v-list-item-subtitle
              >DOB: {{ client.formattedDob }}</v-list-item-subtitle
            >
            <v-list-item-subtitle>{{
              Boolean(client.osis)
                ? "OSIS: " + client.formattedOsis
                : "NYEIS ID: " + client.nyeisId
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <more-client-details-panel></more-client-details-panel>
    </v-list-group>
    <div v-if="isSEITOrRSAdmin">
      <dashboard-message
        v-for="(message, i) in dashboardMessages"
        :key="i"
        :messageText="message"
      ></dashboard-message>
    </div>
    <tabs v-if="!loading" :client="client"></tabs>
  </div>
</template>
<script>
import DashboardMessage from "./dashboard-message";
import Tabs from "./tabs.vue";
import MoreClientDetailsPanel from "./more-client-details-panel";
export default {
  components: {
    DashboardMessage,
    Tabs,
    MoreClientDetailsPanel,
  },
  props: ["clientId", "isSidebar"],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    client() {
      return this.$store.state.clientModule.selectedClient || null;
    },
    isProvider() {
      return this.$store.getters["securityModule/isProvider"];
    },
    isSEITOrRSAdmin() {
      return this.$store.getters["securityModule/isSEITOrRSAdmin"];
    },
    dashboardMessages() {
      return this.$store.state.clientModule.clientDashboard?.messages || [];
    },
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("sharedModule/getProviderId", null, {
      root: true,
    });
    if (this.$route.params.clientId || this.clientId) {
      this.$store.commit("uxModule/setShowLoader", true);
      await this.$store.dispatch(
        "clientModule/getClient",
        this.$route.params.clientId || this.clientId
      );
      if (this.isSEITOrRSAdmin) {
        await this.$store.dispatch(
          "plansModule/getPlansByClient",
          this.$route.params.clientId || this.clientId
        );
        await this.$store.dispatch(
          "clientModule/getClientDashboard",
          this.$route.params.clientId || this.clientId
        );
      }
      if (this.isProvider) {
        await this.$store.dispatch(
          "clientModule/getClientChart",
          this.$route.params.clientId || this.clientId
        );
      } else {
        await this.$store.dispatch(
          "clientModule/getClientChartAdmin",
          this.$route.params.clientId || this.clientId
        );
      }
      this.$store.commit("uxModule/setShowLoader", false);
      this.loading = false;
    } else {
      this.$router.push({ name: "ClientLookup" });
    }
  },
  beforeDestroy() {
    this.$store.dispatch("clientModule/clearClient");
  },
  methods: {
    goBack() {
      this.$store.dispatch("clientModule/clearClient");
      this.$router.push({ name: "ClientLookup" });
    },
  },
};
</script>
